<template>
    <div class="leftNavWrapper">
        <div id="leftFirst">
            <router-link
                v-for="(tab, index) in meniuFront"
                :id="'item_'+index"
                :key="index"
                :to="!tab.hidden ? tab.route : ''"
                :class="{relativeParent: true, 'router-link-active': mainMenuIndex == index, 'hidden': tab.hidden, 'overlay' : tab.overlay && $route.fullPath.includes('m3-sketch')}"
                @click.native="collapseSidebar(index);getFirstChild(tab.child,index, tab.route)"
                @mouseover.native="toggleConsultant(tab.clasaIcon)"
                @mouseleave.native="toggleConsultant(tab.clasaIcon)"
            >
                <span :class="'spriteBg ' + tab.clasaIcon" >
                    <span v-show="!tab.hidden" v-if="tab.tooltip && tab.clasaIcon !== 'consultanti'" class="tooltiptext">{{ tab.tooltip }}</span>
                </span>
                <b-tooltip v-if="tab.hidden" :target="'item_'+index" triggers="hover" placement="right">Disponibil în curând</b-tooltip>
                <ConsultantGoodWill v-if="tab.clasaIcon === 'consultanti'" :consultantVisible="consultantVisible" class="customTooltip"></ConsultantGoodWill>

            </router-link>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="54" viewBox="0 0 30 54">
                <image id="logo_mic_jos_-_catre_home" data-name="logo mic jos - catre home" width="30" height="54" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAYAAADQzyn5AAAGbUlEQVRYhcWZ2W+VZRDGfz09Pe3ppoDWgkBFWSoogl65RUXEfcGIRqPGuEUvNMYb9Q8wbokXmhhjNCYa4cI1riHuVo2KRARBkb0Vq7UFpNRaacFM/L3ms9a2SIFJTk6/7Z13nnnmmflOS9p//R3tcGA8UA38BLQCW9hHlgcqgJuAG4GZuukCmoCXgFeBn0fafUR8PfCUx98Av7qBGs+dAnwy0o4j4nP8+3ngTiCwnyAKncAyoABcBUwFjgQqgUXAGuBWYJKbfghocb2cn4uA+cBhIvcR8HI47vbG2cCVwNfASuAu4DcfXghcYFqSnen1Qzw+A5gBXAxcCJwK/ALcAtTppwhcBrTljDSINBl4EFgMNAOfAtcJ+VydPg6cCyw16u3ApcD9wE5gjqg9o+MLdXofMMXNB0LvRsSvA/OAm4FZRnAocAzwpCzvNPJX3Fhw4ATgw4AN+Bw4HzjWAPI+s0kkA72zgeXhFCiPG8aao9uFLCKcBjwCnCh0u4KIQJn3/OF3qd+7/YT1Zq7dC7wBnAcc5VqB4rM5YXjVSG7R2XHAGBdYPwApcxmH6bik37nYwGhTcK+wP+y1kyPibR7M89OZKaUlwGPAAqNNERf8Lmaiy/c7F5u5Q0ZvUJTqvbYobr4HeEG2Rc0eDKwA3rK+Q73edPHNPrjac194HILzjg7iXC3wnfxZa8k2+PwDQb6sZCJcBXO4m5GzXGbd4Mvf8CQLZz0j6DDZLoXpb8sN+cg+srx1N08xeMN8xO6+l0zdsnOy93ygnu+V5a2xqSrTfFHoNh/lfidGbwS+HQnHOZ03qdGpHl8DfrQWozzaZe0MN7nXFqxukFBFa3iWkK61hCp1cqSb+jijXP/b+pdT1qqs6c0jEWF/S+VUaRS95jp2c7cI/GCUzf1SVOV1XGe3iPQO7vIvi4ijzZ2lUk2VvZ028OjLx6tGTS7ap6TWqcPFTDeKc087PAxqaecxcVxtD33NVhYMflSnC2171wI3AEcoi9fY3YITJwPjXGNYUP9oHg9Rl+fbXwuyuUXCrTPCWmGt9lqrne1wybh4uFBXCvFqF2y0tGrMdZmDwS9KXxqXptgc4tPhPTEerxqO7Ibj2OlW56eBrEwnq4YTyXAt7ww1w9lrpVB2OQjUqV7TLa0ahaTR8+sl3zqnyB7HmyE7W0R8G3CSZRNEed+cx9Twpb35FMttu5stF4kKy+w3qyG0/rnU+gaz1Ce/ci6e7Wx0tINalMgVqtYGB4a5zmjNTpv1PtNqCdYOB+2I+DTgcmAH8KLjalHGlioKOSNvEeYJ1nSL02hCIsj4RP/e+1+OR4Yte2gHbBA4oBNIvBWcpgaP5IA3kBXkxeIkmU37wSmSNSqlJ68et+8Hp/+wfZXjgiLzn5YGgXqVaZpyudHhYKsq1KtkVnm+XvH4XfhqrPdUy+O8d8lgjo+w136uOEQOJtoCOzLj7Rg1ebwC0uEmG722Sm2f7OvLzqEi7nSR6cpiGmM22TzyQrdTmSwVgZxOjvIniR4bxSh7ddtQjnt8k9vibxTTXahV3Z3ky3SDWr7Ehbeq4V9kGsUY/94w1CR6oCSzOi9ZZgthzlzljHSNnarb87NEotM+vN5rk7w+2Qazy1R1+/xqCVklsnPyEqXOCxtVsWZ/1Tkss6G8G2wUxtjU6UYwQfhH67TUXE8U/pT3dtfsTkRaY87WOhSMM/d9nqvwXJq3tjjclTiLFRwkOv0UM28hpSJzqLmPdfoix6nnlugoTRblvpylAb3MnW8XsgUODx+JWHs/QepzzXoZXpKZTKrCca2OOjIsT8LSm4E6W5flCsoWv0uEf1vmnpLB9D+v6ox2kqhwtJ3utaXmNJchVZmbmaiABCfeE+7NOjtIwrU5Vv1LTCLiRtk4wSnzaJ0kKUyjb5LBFpGYlBGUNsnTkJHYmQ6Lb2Xesf4RcZcE2eZLd60bKHOxsUL7tq8nLUa0wyoY5YaWi0yfJDpI0nYNBHVEnAiRy5CrN0O2aq+lgW6Xx+UiUeFxVz9uVJv3ARUs/QJQ40Nl3ljhuYI5rvJa0RxWeP/BkrEr4zBVwY7BZDP9lnm+P7YU7UAz3fEKybNMJ9GZPnMzlZJmmbncI0vwps4Swn2J9RkWhArnkf/oQnFfKFE0lWgOwYWo4T22iDhYGwukVhdEC5IlsQjIItr4/0Q4TcgEjElK98yAPwH6YuLZHGYz0gAAAABJRU5ErkJggg=="/>
            </svg>
        </div>
        <sidebar-menu
            id="leftSecond"
            :class="collapsed ?'hide':''"
            :menu="sendChild"
            :collapsed="collapsed"
            :show-one-child="true"
            :showChild="true"
            @toggle-collapse="onToggleCollapse"
            @item-click="onItemClick"
            @noCompanies="noCompaniesAdded()"
        ></sidebar-menu>

        <sidebar-menu
            v-if="sendChild2 && sendChild2.length > 0"
            id="leftThird"
            :class="collapsed ?'hide':''"
            :menu="sendChild2"
            :collapsed="collapsed"
            :show-one-child="true"
            @toggle-collapse="onToggleCollapse"
            @noCompanies="noCompaniesAdded()"
        ></sidebar-menu>

    </div>
</template>

<script>
    import { SidebarMenu } from 'vue-sidebar-menu'
    import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
    import {BTooltip} from 'bootstrap-vue';
    import ConsultantGoodWill from './ConsultantGoodWill';

    export default {
        components: {
            SidebarMenu,
            BTooltip,
            ConsultantGoodWill
        },
        props:{
            topMenuIsOpened:Boolean,
            favNumberBadge:Number,
        },
        data() {
            return {
                leftNavSecondLevelCollapsed: false,
                sendChild:[],
                sendChild2: [],
                mainMenuIndex: null,
                collapsed: false,
                isOnMobile: false,
                consultantVisible: true,
                leftMenuIsOpened: true,
                openSecondMenu:[],
                consultantId: null,
                meniuFront: [
                    {
                        clasaIcon: "home",
                        tooltip: "SMIS home ",
                        route: "/contul-meu",
                        hidden: true,
                    },
                    {
                        clasaIcon: "finanțări",
                        tooltip: "Finanțări",
                        route: 'finantari',
                        hidden: true,
                        child: [
                            {
                                header: true,
                                title: 'Finanțări',
                                hiddenOnCollapse: true
                            },
                            {
                                title: "Toate finanțările",
                                href: { path: '/toate-finantarile' },
                            },
                            {
                                title: "Calendar finanțări",
                                href: { path: '/calendar-finantari' },
                                badge: {
                                    text: 8,
                                    attributes: {
                                        style: 'background-color: #c5c5c5',
                                    },
                                }
                            },
                            {
                                title: "Harta finanțărilor",
                                href: { path: '/harta-finantarilor' },
                            },
                            {
                                title: "Finanțări favorite",
                                href: { path: '/finantari-favorite' },
                                badge: {
                                    text: this.favNumberBadge,
                                    attributes: {
                                        style: 'background-color: #ff692a'
                                    }
                                },
                            },
                            {
                                title: "Eligibilitate finanțări",
                                href: { path: '/eligibilitate-finantari' },
                            }
                        ]
                    },
                    {
                        clasaIcon: "proiect",
                        tooltip: "Scrie proiect",
                        route: "proiect",
                        hidden: true,
                        child: [
                            {
                                header: true,
                                title: 'Scrie proiect',
                                hiddenOnCollapse: true
                            },
                            {
                                title: "Soluții scriere proiect",
                                href: { path: '/solutii-scriere-proiect' },
                            },
                            {
                                title: "ProjectSketch® by SMIS",
                                href: { path: '/project-sketch-by-smis' },
                            },
                            {
                                title: "ProjectPlanner® by SMIS",
                                href: { path: '/project-planner-by-smis' },
                            },
                            {
                                title: "Scriere Proiect",
                                href: { path: '/scriere-proiect' },
                                icon: "fa fa-list-ul",
                                child: [
                                    {
                                        title: "Măsura 2",
                                        href: { path: '/scriere-proiect/masura-2' },
                                        children: [
                                            {
                                                header: true,
                                                title: "Proiect Nou +",
                                                class: 'button'
                                            },
                                            {
                                                header: true,
                                                title: 'Proiectele mele',
                                            },
                                            {
                                                title: "SMART project in",
                                                href: { path: '/scriere-proiect/masura-2/smart-project-in-implementare' },
                                            },
                                            {
                                                title: "Comunitatea de",
                                                href: { path: '/scriere-proiect/masura-2/comunitatea-se-dezvolta' },
                                            },
                                            {
                                                title: "Start-up nation",
                                                href: { path: '/scriere-proiect/masura-2/startup-nation-manager' },
                                            },
                                        ],
                                    },
                                    {
                                        title: "POCU planner",
                                        href: { path: '/scriere-proiect/pocu-planner' },
                                    },
                                    {
                                        title: "Social project",
                                        href: { path: '/scriere-proiect/social-project' },
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        clasaIcon: "aplicatii",
                        tooltip: "Aplicații",
                        collapsed: false,
                        route: "/aplicatii/m3-status",

                        isOnMobile: false,
                        child: [
                            {
                                header: true,
                                title: 'Aplicații',
                                hiddenOnCollapse: true
                            },
                            /*{
                                title: "Aplicații SMIS",
                                href: { path: '/aplicatii-smis' },
                            },*/
                            {
                                title: "Aplicațiile mele",
                                //                                href: { path: '/aplicatiile-mele' },
                                child: [
                                    {
                                        title: "POCStatus",
                                        href: { path: '/aplicatii/m3-status' },
                                    },
                                    {
                                        title: "POCSketch",
                                        href: { path: '/aplicatii/m3-sketch' },
                                    },
                                    // {
                                    //     title: "Cumpără licență",
                                    //     href: { path: '/licente' },
                                    // },
                                    // {
                                    //     title: "Întrebări frecvente",
                                    //     href: { path: '/intrebari-frecvente' },
                                    // },
                                    {
                                        title: "Deschide un tichet",
                                        href: { path: '/tichete-suport' },
                                    },
                                    // {
                                    //     title: "Notificări",
                                    //     href: { path: '/notificari' },
                                    // },
                                ]
                            },
                        ],
                    },
                    {
                        clasaIcon: "consultanti",
                        tooltip: "Consultanți",
                        route: "#",
                        overlay: true,
                        hidden: false,
                    },
                    {
                        clasaIcon: "joburi-proiecte",
                        tooltip: "Joburi proiecte",
                        route: "/joburi/in-constructie",
                        hidden: true,
                        child: []
                    },
                    {
                        clasaIcon: "comunitate",
                        tooltip: "Comunitatea SMIS",
                        route: "/comunitate/in-constructie",
                        hidden: true,
                        child: []
                    },
                    {
                        clasaIcon: "chat",
                        tooltip: "SMIS Chat",
                        route: "/chat/in-constructie",
                        hidden: true,
                        child: []
                    },
                    {
                        clasaIcon: "forum",
                        tooltip: "Forum",
                        route: "/forum/in-constructie",
                        hidden: true,
                        child: []
                    },
                    {
                        clasaIcon: "marketplace",
                        tooltip: "Marketplace",
                        route: "/marketplace/in-constructie",
                        hidden: true,
                    },
                    {
                        clasaIcon: "termene",
                        tooltip: "Termene.ro",
                        route: "/termene",
                        hidden: false,
                    },
                ],
            };
        },
        watch : {
            topMenuIsOpened:function(){
                if(this.topMenuIsOpened){
                    //this.closeLeftNav()
                }
            },
            "$route":function () {
                if(!this.$route.path.includes('m3-sketch')){
                    this.openLeftMenu()
                }else{
                    this.collapsed = true;
                }
            },
        },
        mounted () {
            this.onResize()
            window.addEventListener('resize', this.onResize)
            if(!this.$route.path.includes('m3-sketch')){
                this.leftMenuOpened();
            }else{
                this.collapsed = true;
            }

        },
        created() {
            if(!this.$route.path.includes('m3-sketch')){
                this.openLeftMenu();
            }else{
                this.collapsed = true;
            }
        },
        methods: {
            toggleConsultant(icon){
                if(icon === 'consultanti'){
                    this.consultantVisible = !this.consultantVisible
                }
            },
            noCompaniesAdded() {
                console.log('emit');
            },
            openLeftMenu(){
                if(this.isOnMobile===false){
                    if(this.$route.path.includes("/")){
                        this.mainMenuIndex = 3;
                        this.sendChild = this.meniuFront[3].child;
                        this.collapseSidebar(2)
                    }
                }
            },
            collapseSidebar(index, hidden){
                if(!hidden && index === 3) {
                    if (this.mainMenuIndex != index) {
                        this.collapsed = false;
                    }
                    if (this.mainMenuIndex == index) {
                        this.collapsed = !this.collapsed;
                    }
                }
            },
            getFirstChild(child,index, path, hidden) {
                if(!hidden && index === 3) {
                    if (path && path.includes("in-constructie")) {
                        this.$router.push({path: path})
                    }
                    this.sendChild2 = [];
                    this.sendChild = child;
                    this.mainMenuIndex = index;
                    this.leftMenuOpened();
                }
            },
            leftMenuOpened(){
                this.leftMenuIsOpened = true;
                this.$emit('leftMenuOpened',this.leftMenuIsOpened)
            },
            getSecondChild(child) {
                if(this.sendChild2 && this.sendChild2.length>0){
                    this.sendChild2 = [];
                }else {
                    this.sendChild2 = child;
                }
                if(child) {
                    this.leftNavSecondLevelCollapsed = !this.leftNavSecondLevelCollapsed;
                }
            },
            getThirdChild(child) {
                this.sendChild3 = child;
            },
            onToggleCollapse (collapsed) {
                this.collapsed = collapsed
            },
            onResize () {
                this.isOnMobile = window.innerWidth <= 767;
            },
            onItemClick(event, item) {
                if(item.children) {
                    this.sendChild2 = item.children;
                } else{
                    this.sendChild2 = null
                }
            },
            closeLeftNav(){
                this.sendChild = []
                this.sendChild2 = []

            },
        },
    };
</script>

<style scoped>
.customTooltip{
    left: 0;
    width: 1000px;
    min-height: 165px;
    max-width: 80vw;
    position: absolute;
    right: auto;
    top: 0;
    z-index: 99999;
    padding-left: 60px;
    display: none;
    transition: 0.3s;
}
a.overlay:hover .customTooltip{
    display: flex;
    transition: 0.3s;
}

.hidden{
    opacity: 0.2 !important;
}
/*.finanțări .tooltiptext, .proiect .tooltiptext, .consultanti .tooltiptext, .joburi-proiecte .tooltiptext, .comunitate .tooltiptext, .chat .tooltiptext, .forum .tooltiptext, .marketplace .tooltiptext{*/
/*    display: none !important;*/
/*}*/
svg{
    margin: 10px;
    position: absolute;
    bottom: 0;
}
.desibled:hover{
    opacity: 0.4 !important;
}
.leftNavWrapper{
    display: flex;
    /*z-index: 0;*/
}
@media(max-height: 790px) {
	#leftFirst{
		padding-top: 20px !important;
	}
}
.overlay{
    position: relative;
}
.overlay:after{
    content: '';
    background: url('../../assets/images/goodwill-overlay.png') no-repeat;
    display: block;
    z-index: 9999;
    position: absolute;
    top: 9px;
    left: 9px;
    right: 0;
    bottom: 0;
}
#leftFirst .router-link-active:not(.hidden):not(.overlay):after{
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 10px 0;
    border-color: transparent #ffffff transparent transparent;
    position: absolute;
    right: -1px;
    top: 0;
    bottom: 0;
    margin: auto;
}
#leftFirst .router-link-active{
    opacity: 1;
}
#leftFirst .router-link-active .tooltiptext{
    font-weight: normal;
    opacity: 1;
}
ul{
    list-style: none;
}

#leftFirst,
#leftSecond,
#leftThird {
    display: flex;
    flex-direction: column;
}
#leftFirst {
    background: linear-gradient(to bottom,#69586e, #22686c);
    flex-grow: 1;
    padding-top: 100px;
    width: 56px;
}
#leftFirst a{
    display: block;
    opacity: 0.4;
}
#leftFirst a:hover{
    display: block;
    opacity: 1;
}
#leftFirst .relativeParent{
    position: relative;
}
#leftFirst a .tooltiptext {
    position: absolute;
    background: #eef2f9;
    color: #676d86;
    font-size: 15px;
    border-radius: 5px;
    padding: 0 10px;
    white-space: nowrap;
    left: 90%;
    top: 0;
    display: none;
    bottom: 0;
    margin: auto;
    height: 30px;
    line-height: 30px;
}
#leftFirst a:hover .tooltiptext{
    display: block;
    z-index: 999;
}
#leftFirst a .tooltiptext::after{
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5.5px 6px 5.5px 0;
    border-color: transparent #eef2f9 transparent transparent;
    position: absolute;
    left: -5px;
    bottom: 0;
    top: 0;
    margin: auto;
}
#leftFirst .spriteBg {
	background: url('../../assets/images/leftNavIcons.png') no-repeat;
	margin: 15px auto;
  display: block;
}
#leftFirst .comunitate {
	background-position: -0px -0px;
	width: 26px;
	height: 17px;
}
#leftFirst .forum {
	background-position: -0px -17px;
	width: 26px;
	height: 17px;
}
#leftFirst .marketplace {
	background-position: -0px -34px;
	width: 25px;
	height: 18px;
}
#leftFirst .proiect {
	background-position: -0px -52px;
	width: 25px;
	height: 23px;
}
#leftFirst .aplicatii {
	background-position: -0px -75px;
	width: 23px;
	height: 21px;
}
#leftFirst .chat {
	background-position: -0px -96px;
	width: 23px;
	height: 22px;
}
#leftFirst .home {
	background-position: -0px -118px;
	width: 22px;
	height: 20px;
}
#leftFirst .joburi-proiecte {
	background-position: -0px -138px;
	width: 22px;
	height: 19px;
}
#leftFirst .consultanti {
	background-position: -0px -157px;
	width: 21px;
	height: 25px;
}
#leftFirst .finanțări {
	background-position: -0px -182px;
	width: 18px;
	height: 27px;
}
#leftFirst .termene {
    background: url("../../assets/images/termene.png");
    width: 26px;
    height: 19px;
}
.isActive{
    display: block !important;
    z-index: 10;
    top: 0;
}
#leftThird h1{
    font-size: 16px;
    font-weight: bold;
    margin-top: 42px;
    margin-bottom: 10px;
    color: #b7b7bb;
}
.hide{
    display:none !important;
}

@media (max-width:767px) {
    .leftNavWrapper{
        z-index: 2;
    }
    #leftSecond  {
        position: absolute !important;
        left: 56px;
        top: 57px;

    }
    #leftThird{
        position: absolute !important;
        left: 56px;
        top:13%;
    }
}
</style>
